<template>
  <b-row class="align-items-end">
    <b-col
      sm="12"
      md="3"
      class="mb-50">
      <SearchTextInput
        v-model="searchName"
        label="OIC Name"
        placeholder="OIC Name"
        @keyup.enter.native="fetchFilter()" />
    </b-col>
    <b-col
      sm="12"
      md="3"
      class="mb-50">
      <SearchTextInput
        v-model="searchPhone"
        label="Phone Number"
        placeholder="Phone Number"
        @keyup.enter.native="fetchFilter()" />
    </b-col>
    <b-col
      sm="12"
      md="3"
      class="mb-50">
      <SearchTextInput
        v-model="searchAddress"
        label="Address"
        placeholder="Address"
        @keyup.enter.native="fetchFilter()" />
    </b-col>
    <b-col
      sm="12"
      md="3"
      class="mb-50">
      <SearchTextInput
        v-model="searchSubDistrict"
        label="SubDistrict"
        placeholder="SubDistrict"
        @keyup.enter.native="fetchFilter()" />
    </b-col>
    <b-col
      sm="12"
      md="3"
      class="mb-50">
      <SearchTextInput
        v-model="searchDistrict"
        label="District"
        placeholder="District"
        @keyup.enter.native="fetchFilter()" />
    </b-col>
    <b-col
      sm="12"
      md="3"
      class="mb-1 mb-sm-0">
      <SearchTextInput
        v-model="searchProvince"
        label="Province"
        placeholder="Province"
        @keyup.enter.native="fetchFilter()" />
    </b-col>
    <b-col
      sm="12"
      md="3"
      class="mb-1 mb-sm-0">
      <SearchTextInput
        v-model="searchZipcode"
        label="Zipcode"
        placeholder="Zipcode"
        @keyup.enter.native="fetchFilter()" />
    </b-col>
    <b-col
      sm="12"
      md="3"
      class="mb-1 mb-sm-0">
      <StatusDropdown
        :status-filter.sync="statusFilterValue"
        @change-status-filter="fetchFilter()"
      />
    </b-col>
    <b-col
      sm="12"
      md="9">
    </b-col>
    <b-col
      sm="12"
      md="3"
      class="mt-1">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        class="w-100"
        variant="primary"
        @click="fetchFilter()">
        <feather-icon
          icon="SearchIcon"
          class="mr-50 mr-md-0 mr-lg-0 mr-xl-50" />
        <span class="align-middle">Search</span>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import SearchTextInput from '@/components/Filter/SearchTextInput.vue'
import StatusDropdown from '@/components/Filter/StatusDropdown.vue'

export default {
  components: {
    SearchTextInput,
    StatusDropdown
  },
  props: {
    filter: {
      type: Object,
      default: () => (
        {
          searchName: '',
          searchPhone: '',
          searchAddress: '',
          searchSubDistrict: '',
          searchDistrict: '',
          searchProvince: '',
          searchZipcode: ''
        }
      )
    },
    statusFilter: {
      type: String,
      default: null
    }
  },
  computed: {
    searchName: {
      get () {
        return this.filter.searchName
      },
      set (val) {
        this.$emit('update:search-name', val)
      }
    },
    searchPhone: {
      get () {
        return this.filter.searchPhone
      },
      set (val) {
        this.$emit('update:search-phone', val)
      }
    },
    searchAddress: {
      get () {
        return this.filter.searchAddress
      },
      set (val) {
        this.$emit('update:search-address', val)
      }
    },
    searchSubDistrict: {
      get () {
        return this.filter.searchSubDistrict
      },
      set (val) {
        this.$emit('update:search-sub-district', val)
      }
    },
    searchDistrict: {
      get () {
        return this.filter.searchDistrict
      },
      set (val) {
        this.$emit('update:search-district', val)
      }
    },
    searchProvince: {
      get () {
        return this.filter.searchProvince
      },
      set (val) {
        this.$emit('update:search-province', val)
      }
    },
    searchZipcode: {
      get () {
        return this.filter.searchZipcode
      },
      set (val) {
        this.$emit('update:search-zipcode', val)
      }
    },
    statusFilterValue: {
      get () {
        return this.statusFilter
      },
      set (val) {
        this.$emit('update:status-filter', val)
      }
    }
  },
  methods: {
    fetchFilter () {
      this.$emit('fetch-filter')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
